import React, { useEffect, useState } from 'react';
import { useBasket } from '../../context/BasketContext';

const BasketTimer = () => {
  const { expiry, clearBasket, clearExpiry } = useBasket();
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    if (!expiry) {
      setTimeLeft(null);
      return;
    }
    const interval = setInterval(() => {
      const now = Date.now();
      const diff = expiry - now;
      if (diff <= 0) {
        setTimeLeft(0);
        clearBasket();
        clearExpiry();
        clearInterval(interval);
      } else {
        setTimeLeft(diff);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [expiry, clearBasket, clearExpiry]);

  if (timeLeft === null) return null;

  const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
  const seconds = Math.floor((timeLeft / 1000) % 60);

  return (
    <div className="d-flex justify-content-center">
      <div style={{ background: '#D32F2F', color: 'white', borderRadius: 8, padding: '4px 16px', fontWeight: 600, marginBottom: 4, fontSize: 16 }}>
        Basket expires in {minutes}:{seconds.toString().padStart(2, '0')}
      </div>
    </div>
  );
};

export default BasketTimer; 